"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/*
Overlay component
  Used for popovers, tooltips
*/
/* eslint-disable jsx-a11y/anchor-is-valid */
var react_1 = __importStar(require("react"));
var react_popper_1 = require("react-popper");
var OutsideClick_1 = __importDefault(require("../OutsideClick/OutsideClick"));
var Overlay = function (_a) {
    var overlayRef = _a.overlayRef, targetRef = _a.targetRef, isVisible = _a.isVisible, placement = _a.placement, childNode = _a.childNode, onMouseEnter = _a.onMouseEnter, onMouseLeave = _a.onMouseLeave, _b = _a.effect, effect = _b === void 0 ? 'fade' : _b, _c = _a.fullWidth, fullWidth = _c === void 0 ? false : _c, onClickOutside = _a.onClickOutside, _d = _a.cssClass, cssClass = _d === void 0 ? '' : _d, _e = _a.showArrow, showArrow = _e === void 0 ? true : _e, _f = _a.refresh, refresh = _f === void 0 ? 0 : _f, onOverlayKeyDown = _a.onOverlayKeyDown;
    var popperRef = react_1.useRef(null);
    if (overlayRef) {
        popperRef = overlayRef;
    }
    var _g = react_1.default.useState('mounting'), animation = _g[0], setAnimationState = _g[1];
    var _h = react_1.useState(null), arrowRef = _h[0], setArrowRed = _h[1];
    var _j = react_1.default.useState(true), firstRender = _j[0], setFirstRender = _j[1];
    var callback = react_1.useCallback(function () {
        if (isVisible) {
            onClickOutside();
        }
    }, [isVisible, onClickOutside]);
    OutsideClick_1.default([targetRef, popperRef], callback);
    react_1.default.useEffect(function () {
        var timeoutId;
        if (animation === 'mounting') {
            timeoutId = window.setTimeout(function () {
                setAnimationState('mounted');
            }, 0);
        }
        return function () {
            clearTimeout(timeoutId);
        };
    }, [animation]);
    var _k = react_popper_1.usePopper(targetRef.current, popperRef.current, {
        placement: placement,
        modifiers: [
            {
                name: 'offset',
                options: {
                    offset: [0, -0]
                }
            },
            {
                name: 'arrow',
                options: {
                    element: arrowRef
                }
            },
            {
                name: 'preventOverflow',
                options: {
                    rootBoundary: 'document' // "viewport"
                }
            }
        ]
    }), styles = _k.styles, attributes = _k.attributes, forceUpdate = _k.forceUpdate;
    react_1.useLayoutEffect(function () {
        if (forceUpdate) {
            forceUpdate();
        }
    }, [forceUpdate, refresh]);
    // Calculate position of tooltip on first render
    if (firstRender && animation === 'mounted') {
        if (forceUpdate) {
            forceUpdate();
        }
        setFirstRender(false);
    }
    var getStyles = function () {
        if (fullWidth) {
            return __assign(__assign({}, styles.popper), { width: '100%' });
        }
        return styles.popper;
    };
    var getClassNames = function () {
        var css = "c-overlay " + cssClass + " " + (showArrow ? ' c-overlay--arrow' : '');
        if (effect === 'fade') {
            if (animation === 'mounted' && isVisible) {
                css += ' o-fade o-fade--show';
            }
            else {
                css += ' o-fade o-fade--hide';
            }
        }
        else {
            css += isVisible ? ' ' : ' u-d-none';
        }
        return css;
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", __assign({ role: "none", className: getClassNames(), onMouseMove: function () { }, onMouseEnter: function (e) {
                onMouseEnter(e);
            }, onMouseLeave: function (e) {
                onMouseLeave(e);
            }, onKeyDown: onOverlayKeyDown, ref: popperRef, style: getStyles() }, attributes.popper),
            react_1.default.createElement("div", { ref: setArrowRed, className: "c-overlay__arrow", style: styles.arrow }),
            react_1.default.createElement("div", { className: "c-overlay__inner" }, childNode))));
};
exports.default = Overlay;
